export const downloadCsv = (fileName: string, csv: string): void => {
  const blob = new Blob([csv]);
  const blobUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.href = blobUrl;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(blobUrl);
  document.body.removeChild(a);
};
